import React, { Dispatch, SetStateAction } from 'react'
import { Pagination } from '@mui/material'

interface Props {
  page: number
  setPage: Dispatch<SetStateAction<number>>
  arrayLength: number
  paginateLength: number
}

function CustomPagination({ page, setPage, arrayLength, paginateLength }: Props) {
  if (arrayLength < 1) return null

  return (
    <Pagination
      color='primary'
      className='auctions-pagination mb-5'
      sx={{
        width: '100%',
        '& .MuiPaginationItem-root.Mui-selected, .MuiPaginationItem-root.Mui-selected:hover': {
          backgroundColor: '#4f7f71',
        },
      }}
      page={page}
      size='large'
      onChange={(e, value) => setPage(value)}
      count={Math.ceil(arrayLength / paginateLength)}
    />
  )
}

export default CustomPagination
